
































































































































import { Component, Vue } from "vue-property-decorator";
import { ActiveNavigation } from "@/types/interfaces";

@Component
export default class SiteHeader extends Vue {
    isOpen = false;
    nav = "";
    bg = "";
    color = "";
    publicPath = process.env.BASE_URL;
    isReady = false;

    get navRoutes(): object {
        const allRoutes = Vue.prototype
            .MgSortByProperty(this.$store.getters.activeNavigation, "order")
            .filter((obj: ActiveNavigation) => {
                return obj.active;
            });

        return allRoutes;
    }

    get displayName(): boolean {
        return this.$store.getters.displayNameInHeader;
    }

    get siteLogo(): string {
        return this.$store.getters.logo;
    }

    get mobileLogo(): string {
        return this.$store.getters.mobileLogo;
    }

    get logoDesc(): string {
        return this.$store.getters.logoDesc;
    }

    get decorImage(): string | boolean {
        if (this.$store.getters.decorImage) {
            return this.publicPath + "img/" + this.$store.getters.decorImage;
        }
        return false;
    }

    get navImage(): string | boolean {
        if (this.$store.getters.navImage) {
            return (
                this.publicPath + "nav-images/" + this.$store.getters.navImage
            );
        }
        return false;
    }

    get conferenceYear(): number {
        return this.$store.getters.conferenceYear;
    }

    get conferenceTitle(): string {
        return this.$store.getters.conferenceName;
    }

    get cssVariables() {
        return this.$store.getters.cssVariables;
    }

    get getLayoutOptions() {
        return this.$store.getters.layoutOptions;
    }

    get unreadMessages() {
        return this.$store.getters.talkUnreads;
    }

    handleNavicon(event: Event, targetSelector: string): void {
        const el = event.target as HTMLAnchorElement;
        const nodeTarget = document.getElementById(targetSelector);

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        if (el) {
            el.classList.toggle("is-active");
        }

        if (nodeTarget) {
            nodeTarget.classList.toggle("is-active");
        }
    }

    shouldShowUnread(routeName: string) {
        return (
            routeName == "/message-center" &&
            this.$store.getters.talkUnreads > 0
        );
    }
}
